// React
import React, { useEffect, useState } from "react";
// React

// CSS
import styles from "./Mobile.module.css";
// CSS

type MobileProps = {
  mobileNumber: string;
};
export interface I_Position {
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
  zIndex?: string;
}

const numberPositionsForLargeScreen: I_Position[] = [
  {
    top: "10%",
    left: "15vw",
    zIndex: "20",
  },
  {
    top: "20%",
    right: "55vw",
    zIndex: "20",
  },
  {
    top: "30%",
    left: "35vw",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "51vw",
    zIndex: "20",
  },
  {
    top: "90%",
    right: "6vw",
    zIndex: "20",
  },
  {
    top: "30%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "45%",
    right: "30vw",
    zIndex: "20",
  },
  {
    top: "40%",
    right: "60vw",
    zIndex: "20",
  },
  {
    top: "35%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "75%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "55%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "60%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "36vw",
    zIndex: "20",
  },
  {
    top: "53%",
    right: "20vw",
    zIndex: "20",
  },
  {
    top: "29%",
    left: "4vw",
    zIndex: "20",
  },
  {
    top: "30%",
    left: "80vw",
    zIndex: "20",
  },
  {
    top: "10%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "70vw",
    zIndex: "20",
  },
  {
    top: "60%",
    left: "90rem",
    zIndex: "20",
  },
  {
    top: "90%",
    right: "30rem",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "66rem",
    zIndex: "20",
  },
  {
    top: "16%",
    left: "20vw",
    zIndex: "20",
  },
  {
    top: "39%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "10%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "13%",
    left: "40vw",
    zIndex: "20",
  },
];

const numberPositionsForSmallScreen: I_Position[] = [
  {
    top: "60%",
    left: "5rem",
    zIndex: "20",
  },
  {
    top: "50%",
    right: "5rem",
    zIndex: "20",
  },
  {
    top: "30%",
    left: "5rem",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "5rem",
    zIndex: "20",
  },
  {
    top: "30%",
    right: "6rem",
    zIndex: "20",
  },
  {
    top: "50%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "30vw",
    zIndex: "20",
  },
  {
    top: "30%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "50%",
    right: "10rem",
    zIndex: "20",
  },
  {
    top: "70%",
    left: "6rem",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "60%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10rem",
    zIndex: "20",
  },
  {
    top: "40%",
    right: "10rem",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "6rem",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10rem",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "10rem",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "6rem",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10rem",
    zIndex: "20",
  },
];

export const fullScreenHandler = (
  _ref: React.RefObject<HTMLDivElement>,
  extraClass?: string,
  onDone?: (status: "exit" | "enter") => void
) => {
  if (!_ref) return;
  if (!_ref.current) return;
  if (!document.fullscreenElement) {
    _ref.current
      ?.requestFullscreen()
      .then(() => {
        console.log("full sc");
        _ref.current?.classList.add(extraClass || "");
        if (typeof onDone === "function") {
          onDone("enter");
        }
      })
      .catch((err) => {
        console.log("err in full sc");
      });
  } else {
    document
      .exitFullscreen()
      .then(() => {
        console.log("exit full sc");
        if (typeof onDone === "function") {
          onDone("exit");
        }
      })
      .catch((err) => {
        console.log("err in exit of full sc");
      });
  }
};

const Mobile: React.FunctionComponent<MobileProps> = ({ mobileNumber }) => {
  const [numberPos, setNumberPos] = useState<I_Position>({
    top: "1rem",
    left: "5rem",
  });

  useEffect(() => {
    const timeOut = setInterval(() => {
      const randomIndex = Math.floor(
        Math.random() * numberPositionsForLargeScreen.length
      );
      setNumberPos(
        window.innerWidth > 1000
          ? numberPositionsForLargeScreen[randomIndex]
          : numberPositionsForSmallScreen[randomIndex]
      );
    }, 5000);
    return () => {
      clearInterval(timeOut);
    };
  }, []);
  return (
    <div
      className={`${styles.mobileNumber} `}
      style={{
        ...numberPos,
      }}
    >
      {mobileNumber}
    </div>
  );
};

export default Mobile;
